<template>
   <div class="transfer-vehicle-card-container">
      <div class="transfer-vehicle-card-wrapper">
         <!-- Vehicle Type -->
         <div class="vehicle-type-wrapper" :class="'vehicle-type-' + routeIndex">
            <span class="vehicle-type">
               {{ transferItem.vehicle.type | ETrfVehicleCategory }}
            </span>
            <span class="txt-normal vehicle-type-mobile-onyl d-lg-none"> ({{ transferItem.vehicle.info }} {{ $t("transfer_phOrSimilar") }})</span>
         </div>

         <!-- Route Informations -->
         <div class="route-informations-wrapper">
            <div class="route-card-wrapper">
               <div class="route-information-body-wrapper">
                  <!-- A Location Wrapper -->
                  <div class="location-wrapper">
                     <!-- Location Icon -->
                     <div class="location-icon-wrapper">
                        <i class="gts-icon icon-transfer-basket-location"></i>
                        <span class="location-mark-name"> A </span>
                     </div>

                     <div class="location-informations">
                        <span class="location-name">{{ handlerLocationName(transferItem.from.destinationName).name }}</span>
                        <div class="location-fullname-wrapper">
                           <span class="location-fullname" v-for="(item, index) in handlerLocationName(transferItem.from.destinationName).locationFullName" :key="`from-${index}`">
                              {{ item }}
                           </span>
                        </div>
                     </div>
                  </div>

                  <!-- Transfer Card Image -->
                  <div class="transfer-card-image-wrapper d-none d-md-flex">
                     <img
                        class="vehicle-image"
                        :src="$constants.cdn + '/transfer/vehicle_type/' + transferItem.vehicle.vehicleTypeId + '.png'"
                        :srcset="`${$constants.cdn + '/transfer/vehicle_type/' + transferItem.vehicle.vehicleTypeId + '.png'} 300w, 
                     ${$constants.cdn + '/transfer/vehicle_type/' + transferItem.vehicle.vehicleTypeId + '.png'} 600w, 
                     ${$constants.cdn + '/transfer/vehicle_type/' + transferItem.vehicle.vehicleTypeId + '.png'} 900w`"
                        sizes="
                                 (max-width: 300px) 300px,
                                 (max-width: 600px) 600px,
                                 (max-width: 900px) 900px,"
                        loading="lazy"
                        alt="Vehicle Image" />
                     <div class="vehicle-representative">
                        <span class="representative-text">{{ $t("transfer_RepresentativeVehicle") }}</span>
                     </div>
                  </div>

                  <!-- B Location Wrapper -->
                  <div class="location-wrapper txt-right">
                     <div class="location-informations">
                        <span class="location-name">{{ handlerLocationName(transferItem.to.destinationName).name }}</span>
                        <div class="location-fullname-wrapper">
                           <span class="location-fullname" v-for="(item, index) in handlerLocationName(transferItem.to.destinationName).locationFullName" :key="index">
                              {{ item }}
                           </span>
                        </div>
                     </div>

                     <!-- Location Icon -->
                     <div class="location-icon-wrapper">
                        <i class="gts-icon icon-transfer-basket-location"></i>
                        <span class="location-mark-name"> B </span>
                     </div>
                  </div>
               </div>
               <div class="route-informations-footer-wrapper">
                  <div class="transfer-facilities-wrapper">
                     <div class="icon-wrapper">
                        <i class="gts-icon icon-transfer-seat"></i>
                        <span>{{ transferItem.vehicle.capacity }}</span>
                     </div>
                     <div class="icon-wrapper">
                        <i class="gts-icon icon-transfer-baggage"></i>
                        <span>{{ transferItem.vehicle.baggage }}</span>
                     </div>
                     <div class="icon-wrapper">
                        <i class="gts-icon icon-transfer-air-condition icon-sm"></i>
                        <i class="gts-icon icon-transfer-lightning icon-sm" />
                     </div>
                  </div>

                  <div class="pickupDate d-lg-none">
                     {{ getPickupDate(transferItem) }} <span v-if="transferItem.flightNumber">{{ "(" + transferItem.flightNumber + ")" }}</span>
                  </div>
               </div>
            </div>
            <div class="route-flight-number">
               <div v-if="transferItem.from.locationType == 9 || transferItem.to.locationType == 9">
                  <template v-if="transferItem.from.locationType != 9 && transferItem.to.locationType == 9">
                     <div class="time-picker-inputs">
                        <UIInput
                           v-model="transferItem.departureFlightNumber"
                           :label="setInputLabels(transferItem.to.locationType, transferItem.from.locationType)"
                           :placeholder="'TK1234'"
                           v-input="{ type: 'alphanumeric', len: [4, 9], required: false, requiredMsg: $t('common_cannotBeEmpty') }" />
                        <TimePicker :label="fmt.label" :type="'departure'" :pickupDateTime="transferItem.departureFlightDateTime" @pickup="handlerPickUpDate" disabled />
                     </div>
                  </template>
                  <template v-else-if="transferItem.from.locationType == 9 && transferItem.to.locationType != 9">
                     <div class="time-picker-inputs">
                        <UIInput
                           v-model="transferItem.arrivalFlightNumber"
                           :label="setInputLabels(transferItem.to.locationType, transferItem.from.locationType)"
                           :placeholder="'TK1234'"
                           v-input="{ type: 'alphanumeric', len: [4, 9], required: false, requiredMsg: $t('common_cannotBeEmpty') }" />
                        <TimePicker :label="fmt.label" :type="'arrival'" :pickupDateTime="transferItem.arrivalFlightDateTime" @pickup="handlerPickUpDate" disabled />
                     </div>
                  </template>
                  <template v-else>
                     <div class="time-picker-inputs">
                        <UIInput
                           v-model="transferItem.arrivalFlightNumber"
                           :label="`${$t('common_arrivalFlightNumber')}`"
                           :placeholder="'TK1234'"
                           v-input="{ type: 'alphanumeric', len: [4, 9], required: false, requiredMsg: $t('common_cannotBeEmpty') }" />
                        <TimePicker :label="fmt.label" :type="'arrival'" :pickupDateTime="transferItem.arrivalFlightDateTime" @pickup="handlerPickUpDate" disabled />
                        <UIInput
                           v-model="transferItem.departureFlightNumber"
                           :label="`${$t('common_departureFlightNumber')}`"
                           :placeholder="'TK1234'"
                           v-input="{ type: 'alphanumeric', len: [4, 9], required: false, requiredMsg: $t('common_cannotBeEmpty') }" />
                        <TimePicker :label="`${$t('TransferCheckout_lblDeparture')}`" :type="'departure'" :pickupDateTime="transferItem.departureFlightDateTime" @pickup="handlerPickUpDate" disabled />
                     </div>
                  </template>
               </div>
               <template v-if="transferItem.from.locationType != 9 && transferItem.to.locationType != 9">
                  <TimePicker :label="fmt.label" :pickupDateTime="transferItem.pickupDateTime" :type="'pickup'" @pickup="handlerPickUpDate" disabled />
               </template>
            </div>
            <div class="transfer-pickup-info">
               <span v-html="handlerTransferCheckoutPickupInfo()"></span>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import moment from "moment";
import TimePicker from "@/components/unitary/form2/UITimePicker.vue";
import UIInput from "@/components/unitary/form2/UIInput.vue";

export default {
   name: "TransferCheckoutCard",
   components: {
      TimePicker,
      UIInput,
   },
   props: {
      transferItem: Object,
      routeIndex: String,
   },
   data() {
      return {
         // 2 : HOTEL/LOCATION
         // 3 : [NEW]
         // 4 : [NEW]
         // 5 : [NEW]
         // 6 : DISTRICT
         // 7 : UNIT
         // 8 : SUB_UNIT
         // 9 : AIRPORT
         transferScenarioMatrix: {
            2: {
               2: "PickupInfo_txtLocToLoc",
               3: "PickupInfo_txtLocToLoc",
               4: "PickupInfo_txtLocToLoc",
               5: "PickupInfo_txtLocToLoc",
               6: "PickupInfo_txtLocToLoc",
               7: "PickupInfo_txtLocToLoc",
               8: "PickupInfo_txtLocToLoc",
               9: "PickupInfo_txtLocToAir",
            },
            3: {
               2: "PickupInfo_txtLocToLoc",
               3: "PickupInfo_txtLocToLoc",
               4: "PickupInfo_txtLocToLoc",
               5: "PickupInfo_txtLocToLoc",
               6: "PickupInfo_txtLocToLoc",
               7: "PickupInfo_txtLocToLoc",
               8: "PickupInfo_txtLocToLoc",
               9: "PickupInfo_txtLocToAir",
            },
            4: {
               2: "PickupInfo_txtLocToLoc",
               3: "PickupInfo_txtLocToLoc",
               4: "PickupInfo_txtLocToLoc",
               5: "PickupInfo_txtLocToLoc",
               6: "PickupInfo_txtLocToLoc",
               7: "PickupInfo_txtLocToLoc",
               8: "PickupInfo_txtLocToLoc",
               9: "PickupInfo_txtLocToAir",
            },
            5: {
               2: "PickupInfo_txtLocToLoc",
               3: "PickupInfo_txtLocToLoc",
               4: "PickupInfo_txtLocToLoc",
               5: "PickupInfo_txtLocToLoc",
               6: "PickupInfo_txtLocToLoc",
               7: "PickupInfo_txtLocToLoc",
               8: "PickupInfo_txtLocToLoc",
               9: "PickupInfo_txtLocToAir",
            },
            6: {
               2: "PickupInfo_txtLocToLoc",
               3: "PickupInfo_txtLocToLoc",
               4: "PickupInfo_txtLocToLoc",
               5: "PickupInfo_txtLocToLoc",
               6: "PickupInfo_txtLocToLoc",
               7: "PickupInfo_txtLocToLoc",
               8: "PickupInfo_txtLocToLoc",
               9: "PickupInfo_txtLocToAir",
            },
            7: {
               2: "PickupInfo_txtLocToLoc",
               3: "PickupInfo_txtLocToLoc",
               4: "PickupInfo_txtLocToLoc",
               5: "PickupInfo_txtLocToLoc",
               6: "PickupInfo_txtLocToLoc",
               7: "PickupInfo_txtLocToLoc",
               8: "PickupInfo_txtLocToLoc",
               9: "PickupInfo_txtLocToAir",
            },
            8: {
               2: "PickupInfo_txtLocToLoc",
               3: "PickupInfo_txtLocToLoc",
               4: "PickupInfo_txtLocToLoc",
               5: "PickupInfo_txtLocToLoc",
               6: "PickupInfo_txtLocToLoc",
               7: "PickupInfo_txtLocToLoc",
               8: "PickupInfo_txtLocToLoc",
               9: "PickupInfo_txtLocToAir",
            },
            9: {
               2: "PickupInfo_txtAirToLoc",
               3: "PickupInfo_txtAirToLoc",
               4: "PickupInfo_txtAirToLoc",
               5: "PickupInfo_txtAirToLoc",
               6: "PickupInfo_txtAirToLoc",
               7: "PickupInfo_txtAirToLoc",
               8: "PickupInfo_txtAirToLoc",
               9: "PickupInfo_txtAirToAir",
            },
         },
         LABELS: {
            DEPARTURE: this.$i18n.t("transferDatePicker_lblFlightDeparture"),
            LANDING: this.$i18n.t("transferDatePicker_lblFlightLanding"),
            PICKUP: this.$i18n.t("transferDatePicker_lblPickup"),
            RETURN: this.$i18n.t("transferDatePicker_lblReturn"),
         },
      };
   },
   computed: {
      fmt() {
         const fromAirport = this.transferItem.from.locationType === 9;
         const toAirport = this.transferItem.to.locationType === 9;
         const isReturn = this.routeIndex === "2";

         // OUTBOUND (Gidiş)
         if (!isReturn) {
            if (!fromAirport && toAirport) return { label: this.LABELS.DEPARTURE };
            if (fromAirport && !toAirport) return { label: this.LABELS.LANDING };
            if (!fromAirport && !toAirport) return { label: this.LABELS.PICKUP };
            if (fromAirport && toAirport) return { label: this.LABELS.LANDING };
         }

         // RETURN (Dönüş - yön tersine çevrilir)
         if (isReturn) {
            if (!toAirport && fromAirport) return { label: this.LABELS.LANDING };
            if (toAirport && !fromAirport) return { label: this.LABELS.DEPARTURE };
            if (!toAirport && !fromAirport) return { label: this.LABELS.RETURN };
            if (toAirport && fromAirport) return { label: this.LABELS.LANDING };
         }

         return { label: null };
      },
   },
   created() {
      if (this.transferItem.to.locationType == 9) {
         this.transferItem.departureFlightDateTime = this.transferItem.pickupDateTime;
      }
      if (this.transferItem.from.locationType == 9) {
         this.transferItem.arrivalFlightDateTime = this.transferItem.pickupDateTime;
      }
   },
   methods: {
      getPickupDate(transfer) {
         var date = moment(transfer.pickupDateTime);
         return date.format("DD.") + this.$i18n.t("common_" + date.format("MMM").toLowerCase()) + date.format(".YYYY - HH:mm");
      },
      setInputLabels(toLocType, fromLocType) {
         return toLocType == 9 && fromLocType != 9
            ? this.$t("common_departureFlightNumber")
            : toLocType != 9 && fromLocType == 9
            ? this.$t("common_arrivalFlightNumber")
            : toLocType == 9 && fromLocType == 9
            ? this.$t("common_arrivalFlightNumber")
            : this.$t("common_flightNumber");
      },
      handlerLocationName(name) {
         const nameArr = name.split(",");
         const locationFullName = name.split(",");
         locationFullName.shift();
         return {
            name: nameArr[0],
            locationFullName: locationFullName,
         };
      },
      handlerTransferCheckoutPickupInfo() {
         const self = this;

         const departureTime = self.$options.filters.TimeFormat(moment(self.transferItem.departureFlightDateTime).subtract(2, "hours"));
         const transferTime = self.$options.filters.TimeFormat(moment(self.transferItem.pickupDateTime));
         const fromNameInfo = self.transferItem.from.destinationName.split(",")[0];
         const toNameInfo = self.transferItem.to.destinationName.split(",")[0];
         let scenario = self.transferScenarioMatrix[self.transferItem.from.locationType][self.transferItem.to.locationType];

         return self
            .$t(scenario)
            .replace("#VALUE1#", `<strong>${fromNameInfo}</strong>`)
            .replace("#VALUE2#", `<strong>${toNameInfo}</strong>`)
            .replace("#VALUE3#", `<strong>${departureTime != "Invalid date" ? departureTime : transferTime}</strong>`);
      },
      handlerPickUpDate(obj) {
         const { generatedDate, type } = obj;

         switch (type) {
            case "pickup":
               this.transferItem.pickupDateTime = moment(generatedDate).format(this.$constants.dateTimeFormat);
               break;
            case "arrival":
               this.transferItem.arrivalFlightDateTime = moment(generatedDate).format(this.$constants.dateTimeFormat);
               break;
            case "departure":
               this.transferItem.departureFlightDateTime = moment(generatedDate).format(this.$constants.dateTimeFormat);
               break;
            default:
               this.transferItem.pickupDateTime = moment(generatedDate).format(this.$constants.dateTimeFormat);
         }
      },
   },
};
</script>

<style lang="scss">
.route-informations-wrapper {
   .transfer-pickup-info {
      strong {
         font-weight: 600 !important;
         padding: 0 0.25rem;
      }
   }
}
</style>

<style lang="scss">
.transfer-card-image-wrapper {
   width: 300px;
   z-index: 1;
   position: relative;
   left: 0;
   top: -50px;
   right: 0;
   margin: auto;

   .vehicle-image {
      position: absolute;
   }

   .vehicle-representative {
      position: relative;
      width: 90px;
      height: 90px;
      top: 35px;
      left: 18px;
      text-align: center;
      background-repeat: no-repeat;
      transform: rotate(-45deg);
      background-position: center;
      opacity: 0.75;
      background-image: url(data:image/svg+xml;base64,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);
      .representative-text {
         position: absolute;
         inset: 0 0 0 0;
         font-weight: bold;
         margin: auto;
         height: fit-content;
         font-size: var(--xsmall);
      }
   }
}
</style>
<style lang="scss" scoped>
.transfer-vehicle-card-wrapper {
   display: flex;

   @media (max-width: 992px) {
      flex-direction: column;
   }

   .vehicle-type-wrapper {
      display: flex;
      align-items: center;
      max-height: 216px;
      border: 1px solid var(--gray-300);
      border-radius: 1rem;
      min-width: 45px;
      margin-right: 1rem;
      position: relative;

      @media (max-width: 992px) {
         margin-bottom: 1rem;
         margin-right: 0rem;
         margin-right: 0rem;
         padding: 0.5rem 0;
      }

      .vehicle-type {
         text-align: center;
         -ms-writing-mode: tb;
         writing-mode: tb;
         transform: rotate(180deg);
         margin-left: 0.5rem;
         margin-right: 0.5rem;
         font-size: var(--large);
         font-weight: 600;

         @media (max-width: 992px) {
            transform: rotate(0);
            writing-mode: lr;
            -ms-writing-mode: tb;
            margin-right: 0;
            margin-right: 0.5rem;
         }
      }

      &::after {
         content: "";
         position: absolute;
         right: 0;
         width: 6px;
         top: 3rem;
         bottom: 3rem;
         border-top-left-radius: 0.5rem;
         border-bottom-left-radius: 0.5rem;
      }

      &.vehicle-type-1 {
         &::after {
            background: var(--teal-300);
         }
      }
      &.vehicle-type-2 {
         &::after {
            background: var(--gray-800);
         }
      }
      .vehicle-type-mobile-onyl {
         font-weight: 400;
         display: block;
      }
   }

   .route-informations-wrapper {
      width: 100%;
      padding-bottom: 0;
      border-bottom: 3px dashed var(--gray-300);
      position: relative;
      .route-card-wrapper {
         border: 1px solid var(--gray-300);
         //background-color: var(--gray-50);
         background-color: var(--gray-0);
         max-height: 216px;
         height: 216px;
         border-radius: 1rem;

         @media (max-width: 768px) {
            height: auto;
            max-height: none;
         }

         .route-information-body-wrapper {
            display: flex;
            width: 100%;
            height: 176px;
            justify-content: space-between;
            padding: 0 1.5rem;
            padding-top: 2rem;

            @media (max-width: 768px) {
               flex-direction: column;
               height: auto;
               padding-top: 1rem;
            }

            .location-wrapper {
               display: flex;
               margin-bottom: 1.25rem;
               .location-icon-wrapper {
                  position: relative;
                  margin-right: 0.5rem;
                  line-height: 2.5rem;

                  i {
                     $iconDim: 42px !important;
                     filter: brightness(0);
                     width: $iconDim;
                     height: $iconDim;
                  }
                  .location-mark-name {
                     position: absolute;
                     top: 0;
                     left: 0;
                     right: 0;
                     bottom: 0;
                     margin: auto;
                     //color: var(--gray-50);
                     color: var(--gray-0);
                     font-weight: 600;
                     font-size: 1.5rem;
                     width: fit-content;
                  }
               }
               .location-informations {
                  display: flex;
                  flex-direction: column;

                  span.location-name {
                     font-weight: 600;
                  }

                  .location-fullname-wrapper {
                     display: flex;
                     flex-direction: column;
                  }
               }

               &.txt-right {
                  text-align: right;

                  @media (max-width: 768px) {
                     text-align: left;
                     flex-direction: row;
                  }

                  .location-icon-wrapper {
                     margin-left: 0.5rem;

                     @media (max-width: 768px) {
                        margin-left: 0;
                        margin-right: 0.5rem;
                        order: -1;
                     }
                  }
               }
            }
         }

         .route-informations-footer-wrapper {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: var(--gray-100);
            height: 40px;
            padding: 0.25rem 1rem;
            border-bottom-right-radius: 1rem;
            border-bottom-left-radius: 1rem;

            .transfer-facilities-wrapper {
               display: flex;

               .icon-wrapper {
                  display: flex;
                  align-items: center;
                  margin-right: 1rem;
               }
            }
            .time-pickers-wrapper {
               display: flex;
               flex-direction: column;
               align-items: flex-end;
            }

            .pickupDate {
               font-weight: 500;
            }
         }
      }
      .route-flight-number {
         margin-top: 2rem;
         display: flex;
         justify-content: center;

         div {
            @media (max-width: 400px) {
               width: 100%;
            }

            .time-picker-inputs {
               display: flex;
               justify-content: space-between;

               @media (max-width: 400px) {
                  flex-direction: column;
                  .time-picker {
                     margin-left: 0 !important;
                     margin-top: 1rem;
                  }
               }

               .time-picker {
                  margin-left: 1rem;
                  margin-right: 2rem;
               }
            }
         }
      }
      .transfer-pickup-info {
         display: flex;
         justify-content: center;
         margin-bottom: 24px;
         margin-top: 30px;
      }
   }
}
</style>
